import React from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import "./PublicLayout.css";
import PublicVerifiedTradeHeader from "../../pages/PublicVerifiedTrade/PublicVerifiedTradeHeader";
import { Container } from "react-bootstrap";
import PublicVerifiedFooter from "../../pages/PublicVerifiedTrade/PublicVerifiedFooter";

const PublicLayout = () => {
  return (
    <div className="publicWebLayout">
      <Container fluid style={{display:"flex",flexDirection:"column",justifyContent:"space-between",height:"100dvh"}} className='p-0'>
        <PublicVerifiedTradeHeader />
        <div className="custom-container" style={{ flex: 1, overflow: "auto", alignItems: "flex-start", overflow: "auto",
    scrollbarWidth: "none",   
    msOverflowStyle: "none"    }}>
         <Outlet />
        </div>
        <ScrollRestoration />
        <PublicVerifiedFooter />
      </Container>
    </div>
  );
};

export default PublicLayout;
